
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/account/gifts",
      function () {
        return require("private-next-pages/d/account/gifts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/account/gifts"])
      });
    }
  